export const DEFAULT_API_BASE_URL = 'https://tapreward.jitihada.co.tz';

/**
 * API base URL rules:
 * - REACT_APP_API_URL set → use that URL (dev + production)
 * - REACT_APP_USE_SAME_ORIGIN=true → /api/* on current host (production)
 * - Development fallback: DEFAULT_API_BASE_URL
 * - Production fallback: DEFAULT_API_BASE_URL
 */
export function getApiBaseUrl() {
  const envUrl = process.env.REACT_APP_API_URL?.trim();

  if (envUrl) {
    return envUrl.replace(/\/$/, '');
  }

  if (process.env.REACT_APP_USE_SAME_ORIGIN === 'true') {
    return '';
  }

  return DEFAULT_API_BASE_URL;
}

export function apiUrl(path) {
  const normalizedPath = path.startsWith('/') ? path : `/${path}`;
  const baseUrl = getApiBaseUrl();

  if (!baseUrl) {
    return normalizedPath;
  }

  return `${baseUrl}${normalizedPath}`;
}
